import React from 'react'
import { VStack, HStack, Text, Image, Divider } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import StoreCoinSvg from '@images/store_coin.svg'

export const PurchaseSummary = ({ coinCount, price }) => (
  <VStack w="100%" bg="white" align="stretch" spacing={0} borderRadius="4px" border="1px solid" borderColor="divider.light">
    {/* コイン購入数 */}
    <HStack justify="space-between" align="center" px="16px" py="16px">
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        コイン購入数
      </Text>
      <HStack spacing={1}>
        <Image w="20px" h="20px" src={buildAssetUrlString(StoreCoinSvg)} />
        <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
          {coinCount.toLocaleString()}
        </Text>
      </HStack>
    </HStack>

    {/* 区切り線 */}
    <Divider borderColor="divider.light" />

    {/* お支払い金額 */}
    <HStack justify="space-between" align="center" px="16px" py="16px">
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        お支払い金額
      </Text>
      <Text fontSize="md" fontWeight="600" color="label.primary" lineHeight="22px">
        ¥{price.toLocaleString()}
        <Text as="span" fontSize="xs" fontWeight="400" ml="4px">
          (税込)
        </Text>
      </Text>
    </HStack>
  </VStack>
)
